import React from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import { Hammer } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function AdminPlaceholder({ title }) {
  const { t } = useLanguage();

  return (
    <AdminLayout title={title}>
      <div className="flex flex-col items-center justify-center py-20 bg-white border border-dashed border-stone-200 rounded-xl">
        <div className="w-16 h-16 bg-stone-50 rounded-full flex items-center justify-center mb-6">
          <Hammer className="w-8 h-8 text-stone-300" />
        </div>
        <h2 className="text-xl font-serif text-stone-900 mb-2">
          {t("common.coming_soon") || "Coming Soon"}
        </h2>
        <p className="text-stone-500 text-center max-w-sm px-4">
          Halaman ini sedang dalam pengembangan. Silakan kembali lagi nanti untuk fitur selengkapnya.
        </p>
      </div>
    </AdminLayout>
  );
}
